import { render, staticRenderFns } from "./EventsShow.vue?vue&type=template&id=517931b4&scoped=true&"
import script from "./EventsShow.vue?vue&type=script&lang=js&"
export * from "./EventsShow.vue?vue&type=script&lang=js&"
import style0 from "./EventsShow.vue?vue&type=style&index=0&id=517931b4&scoped=true&lang=scss&"
import style1 from "./EventsShow.vue?vue&type=style&index=1&id=517931b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517931b4",
  null
  
)

export default component.exports